export function isEmptyObject(v: unknown): v is Record<string, unknown> {
    return v != null &&
        typeof v === 'object' &&
        !Array.isArray(v) &&
        Object.keys(v as Record<string, unknown>).length === 0;
}
